import { SVGProps } from "react";

const VerifiedCheckSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14.0058 14.0058"
    fill="none"
    {...props}
  >
    <path
      d="M10.5029 4.66952L6.13118 9.33618L3.50292 6.53735"
      stroke="#008001"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VerifiedCheckSvg;
